<template>
  <div>
    <img :src="require('@/assets/yip-duck-fullbody.png')" class="yippi-duck">
    <el-container>
      <el-main :style="{ backgroundImage: 'url(' + require('@/assets/bg-and.png') + ')' }">

        <el-row type="flex">
          <el-col :xs="1" :lg="6">
            <div class="sideDiv">&nbsp;</div>
          </el-col>

          <el-col :xs="22" :lg="12">
            <div class="">&nbsp;</div>
          </el-col>

          <el-col :xs="1" :lg="6">
            <div class="sideDiv">&nbsp;</div>
          </el-col>
        </el-row>

        <el-row type="flex">
          <el-col :xs="1" :sm="4" :lg="6">
            <div class="sideDiv">&nbsp;</div>
          </el-col>

          <el-col :xs="22" :sm="16" :lg="12">
            <div class="white-lg-bg">&nbsp;</div>
          </el-col>

          <el-col :xs="1" :sm="4" :lg="6">
            <div class="sideDiv">&nbsp;</div>
          </el-col>
        </el-row>

        <el-row type="flex">
          <el-col :xs="1" :sm="4" :lg="6">
            <div class="sideDiv">&nbsp;</div>
          </el-col>

          <el-col :xs="22" :sm="16" :lg="12">
            <div class="white-lg-bg contentResize">
              <successTransaction v-if=" this.$route.query.responseCode == 1" :yipps-point="yipps_point" />
              <failTransaction v-else />
            </div>
          </el-col>

          <el-col :xs="1" :sm="4" :lg="6">
            <div class="sideDiv">&nbsp;</div>
          </el-col>
        </el-row>

        <el-row type="flex">
          <el-col :xs="1" :sm="4" :lg="6">
            <div class="sideDiv">&nbsp;</div>
          </el-col>

          <el-col :xs="22" :sm="16" :lg="12">
            <div class="white-lg-bg">
              <div class="content-2">&nbsp;</div>
              <div class="content-2"><span>REF ID: {{ this.$route.query.trxRefId }}</span> </div>
              <div class="content-2"><span>{{ this.$route.query.trxDate }}</span> </div>
            </div>
          </el-col>

          <el-col :xs="1" :sm="4" :lg="6">
            <div class="sideDiv">&nbsp;</div>
          </el-col>
        </el-row>

        <el-row type="flex">
          <el-col :xs="1" :sm="4" :lg="6">
            <div class="sideDiv">&nbsp;</div>
          </el-col>

          <el-col :xs="24" :sm="16" :lg="12">
            <div style="text-align:center" class="white-lg-bg">
              <el-button id="buttonStyle" @click="goBack">{{ $t("gateWayResponse.backButton") }} {{ countDown }}</el-button>
            </div>
          </el-col>

          <el-col :xs="1" :sm="4" :lg="6">
            <div class="sideDiv">&nbsp;</div>
          </el-col>
        </el-row>

      </el-main>
    </el-container>
  </div>

</template>

<script>
import successTransaction from './successTransaction.vue'
import failTransaction from './failTransaction.vue'

export default {
  components: {
    successTransaction,
    failTransaction
  },
  data() {
    return {
      countDown: 10,
      yipps_point: this.$route.query.yipps_point
    }
  },
  computed: {
  },
  created() {
    this.countDownTimer()
    // this.$store.dispatch('authStore/fetchUserInfo')
  },
  methods: {
    goBack() {
      this.$router.replace('/')
    },
    countDownTimer() {
      if (this.countDown === 0) { this.$router.replace('/') }

      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>

  .el-container .el-main {
    width: 1024px;
    background-size:100% 100%;
    position: relative;
    min-height: 90vh;
  }

  #content-rectangle {
    width: 598px;
    height: 540px;
    background-color: #B3C0D1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .content-1{
  height: 124px;
  font-size: 44px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  margin-right: 40px;
  margin-left: 40px;
  }

  .content-2{
  height:40px;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #9b9b9b;
  }

.el-button {
  width: 50%;
  background-color: #f5c923;
  font-size: 18px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  }

.burlywood-bg{
  background-color: burlywood;
  height: 130px;
}

.white-lg-bg{
  background-color: white;
  height: 130px;
}

.white-sm-bg{
  background-color: white;
  height: 80px;
}

.sideDiv{
  height: 130px;
}

.side-xs-div{
  height: 80px;
}

.sideDiv1{
  background-color: palegreen;
  height: 130px;
}

.sideDiv2{
  background-color: plum;
  height: 130px;
}

@media screen and (min-width: 601px) {
  div.contentResize {
    font-size: 30px;
  }

  .yippi-duck{
    position: absolute;
    left: 45%;
    top: 18%;
    z-index: 100;
  }
}

@media screen and (max-width: 600px) {
  div.contentResize {
    font-size: 18px;
  }

  .yippi-duck{
    position: absolute;
    left: 35%;
    top: 18%;
    z-index: 100;
  }
}

#buttonStyle{
  min-width: 80%;
  max-width: 90%;
  background-color: #f5c923;
  font-size: 18px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}

</style>
